<template lang="html">
  <div class="main">
    <page-break v-if="isOnBreak" />
    <template v-else>
      <page-header />
      <main class="container">
        <router-view />
      </main>
      <page-footer />
    </template>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'
import PageBreak from '@/components/PageBreak'
import { LeadStatus } from '@/constants'

export default {
  components: {
    PageHeader,
    PageFooter,
    PageBreak
  },
  computed: {
    isOnBreak() {
      return process.env.VUE_APP_ON_BREAK
    }
  },
  watch: {
    '$store.getters.failedLeads'(current, previous) {
      const newFailedLeads = current.filter(lead =>
        previous.every(({ id }) => id !== lead.id)
      )

      newFailedLeads.forEach(lead => {
        const config = {
          position: 'top-right',
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: false,
          hideProgressBar: true,
          closeButton: 'button',
          icon: true,
          onClick: () => {
            this.$router.push({
              name: 'requests-history',
              params: {
                flightId: lead.data.flight
              },
              query: {
                lead: lead.id
              }
            })
          }
        }

        if (lead.status === LeadStatus.INTERRUPTED) {
          this.$toast.error(
            `Wysyłanie zgłoszenia do lotu ${lead.data.flight_number} zostało przerwane`,
            config
          )
        } else if (lead.status === LeadStatus.FAILED) {
          this.$toast.error(
            `Wystąpił błąd podczas dodawania zgłoszenia do lotu ${lead.data.flight_number}`,
            config
          )
        } else if (lead.status === LeadStatus.DUPLICATE) {
          this.$toast.warning(
            `Wykryto duplikat podczas dodawania zgłoszenia do lotu ${lead.data.flight_number}`,
            config
          )
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '/assets/sass/index';

.container {
  padding: 80px 15px 0px;
  background: $gray-light;
}

.page {
  max-width: calc(510px + 44px * 2);
  margin: 0 auto;
  padding: 38px 44px 65px;

  @include media-down(md) {
    padding: 25px 0px 40px;
  }

  .title {
    @include main-title;

    @include media-down(md) {
      margin: 0 auto;
    }

    &.second {
      margin: 30px 0;
    }
  }

  .arrow {
    width: 10px;
    height: 10px;
    border-right: 2px solid $black;
    border-top: 2px solid $black;
    transform: rotate(45deg);

    &--left {
      transform: rotate(-135deg);
    }
  }

  .navigation {
    margin: 70px 0 0;
    display: flex;
    justify-content: center;

    @include media-down(md) {
      flex-direction: column-reverse;
      margin: 30px 0 0;
    }
  }

  .btn {
    cursor: pointer;

    &--check {
      width: auto;
      margin: 25px auto;
    }

    &--disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    &:focus {
      outline: none;
    }
  }

  .loader {
    display: flex;
    justify-content: center;
  }
}
</style>
